import { Component, OnInit ,Inject} from '@angular/core';
import {MatDialogRef,MAT_DIALOG_DATA} from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { $DBManagerService } from '../../DB/DBManager.service';
import { Constants } from '../../../_utils/Constants';
//import {PrincipalHeaderRegistrationComponent, DialogData} from '../../../_root/Trai_module/_pages/principal-header-registration/principal-header-registration.component';
import { EntitySummaryComponent,DialogData } from '../../../_root/Trai_module/_pages/entity-summary/entity-summary.component';
export interface DialogData {
  
  //setValue: string,
  //setRole: string
}

// set values to the role dropdown
export interface RoleArray
{
  
  value: string
}

 export interface status {
  value: string;
  viewValue: string;
}
 
@Component({
  selector: 'app-entity-dialog',
  templateUrl: './entity-dialog.component.html'
  
})
export class EntityDialogComponent implements OnInit {
	
  constructor(
    public dialogRef1: MatDialogRef<EntitySummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,private db: $DBManagerService)
     { }


  dialogForm: FormGroup;
 

  get f() { return this.dialogForm.controls; };

  ngOnInit() { 
    this.dialogForm = this.fb.group({
      reasonReject:['']
  });


  }

  onSubmit() {
	  this.dialogRef1.close({data:this.dialogForm.controls.reasonReject.value, action:"submit"});
    //this.onNoClick()
  }

  onNoClick(): void {
    this.dialogRef1.close("");
  }


}
